<template>
  <svg width="16px" height="16px"
       viewBox="0 0 16 16" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/16x16/info/white</title>
    <g id="atoms/icons/16x16/info/white" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M8,5 C8.55228475,5 9,5.44771525 9,6 L9,12 L9.5,12 C10.0522847,12 10.5,12.4477153 10.5,13 C10.5,13.5522847 10.0522847,14 9.5,14 L6.5,14 C5.94771525,14 5.5,13.5522847 5.5,13 C5.5,12.4477153 5.94771525,12 6.5,12 L7,12 L7,7 C6.44771525,7 6,6.55228475 6,6 C6,5.44771525 6.44771525,5 7,5 L8,5 Z M8,4 C8.69035594,4 9.25,3.44035594 9.25,2.75 C9.25,2.05964406 8.69035594,1.5 8,1.5 C7.30964406,1.5 6.75,2.05964406 6.75,2.75 C6.75,3.44035594 7.30964406,4 8,4 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
